import React, { useState, useEffect } from 'react'; 
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import styled from 'styled-components';
import server from 'server/serverController2';

import BottomModal from 'components/presenters/modal/BottomModal';
import CommentList from 'components/containers/comment/list/CommentList'; 
import CommentReplyList from 'components/containers/comment/list/CommentReplyList';
import CreateCommentReplyModal from 'components/containers/comment/modal/CreateCommentReplyModal';
import EditCommentModal from 'components/containers/comment/modal/EditCommentModal';
import AddCommentReplyBtnBar from 'components/presenters/comment/list/AddCommentReplyBtnBar';

import BottomTextArea from 'components/containers/input/BottomTextArea';
import Presenter from 'components/presenters/comment/list/CommentItem'
import CommentForm from 'components/presenters/comment/modal/CommentForm';
import { CommentActions } from 'store/actionCreators';
import { removeItem } from 'utils/utils';
export default function CommentItem({
	listType,	//'comment_list', 'reply_list'
	listItemType,//'comment_list_item', 'comment_list_reply' ,'reply_list_parent' , 'reply_list_item'
	comment, targetNo, type, wrapperStyle, 
	onUpdateComment, onDeleteComment,
	onReplyInserted, onReplyDeleted, onReplyUpdated
	}) {    

    const userInfo = useSelector((state) => {
        return state.userInfo
    })

	//api end point
	let deleteCommentEndPoint, likeCommentEndPoint, unlikeCommentEndPoint;
	if(comment)
	{
		if(type === 'campaign_post')
		{
			deleteCommentEndPoint =  `campaigns/posts/comments/${comment['no']}`;
			likeCommentEndPoint = `campaigns/posts/comments/${comment['no']}/like`; 
			unlikeCommentEndPoint = `campaigns/posts/comments/${comment['no']}/like`;
		}  
	}

    const currUserNo = parseInt(userInfo.id);
    const commentUserNo = parseInt(comment?.user_no);

	const [showAddCommentModal, setShowAddCommentModal] = useState(false);

	const [replyContent, setReplyContent] = useState('');
	const [currBottomInputHeight, setCurrBottomInputHeight] = useState(70);
	const [bottomInputFocus, setBottomInputFocus] = useState(false);
	const [insertedReplyList, setInsertedReplyList] = useState([]);
	const [deletedReplyItem, setDeletedReplyItem] = useState(null);
	const [updatedReplyItem, setUpdatedReplyItem] = useState(null);

	const [initReplyList, setInitReplyList] = useState(comment.children)
	//edit modal state
	const [showEditModal, setShowEditModal] = useState(false);
	//bottom modal state
	const [bottomModalVisible, setBottomModalVisible] = useState(false);
	const [bottomModalDataList, setBottomModalDataList] = useState([]);

	useEffect(()=>{
		if(![null, undefined].includes(updatedReplyItem))
		{
			if(initReplyList)
			{
				const newInitReplyList = [...initReplyList]	;
				for(let i = 0; i < newInitReplyList.length; ++i)
				{
					if(parseInt(newInitReplyList[i]['no'])===parseInt(updatedReplyItem['no']))
					{
						newInitReplyList[i] = {...newInitReplyList[i], ...updatedReplyItem}
					}
				}
				setInitReplyList(newInitReplyList);
			}
			
		}
	},[updatedReplyItem])

	const likeComment = () => {
		server.postRequestData(likeCommentEndPoint, {}, (res)=>{
			try
			{
				if(res.success !== 1)
				{
					return;
				}
				const jsonData = res.data;
				const updatedItem = Object.assign({},comment);
				updatedItem['liked_comment'] = true;
				updatedItem['total_like'] = (updatedItem['total_like'])?parseInt(updatedItem['total_like'])+1:1; 
				onUpdateComment(updatedItem);
				 
			} 
			catch(err)
			{
				console.log(err);
			}
		})
	}

	const unlikeComment = () => {
		server.deleteRequestData(unlikeCommentEndPoint, {}, (res)=>{
			try
			{
				if(res.success !== 1)
				{
					return;
				}
				const jsonData = res.data;
				const updatedItem = Object.assign({},comment);
				updatedItem['liked_comment'] = false;
				updatedItem['total_like'] = (updatedItem['total_like'])?parseInt(updatedItem['total_like'])-1:0; 
 				onUpdateComment(updatedItem);
				 
			} 
			catch(err)
			{
				console.log(err);
			}
		})
	}

	const deleteComment = () => {
		let form = {}
		server.deleteRequestData(deleteCommentEndPoint,form,(res)=>{
			try
			{
				if(res.success !== 1)
				{
					return;
				}
				const jsonData = res.data;
				const deletedItem = jsonData['deleted_item'][0];
				if(onDeleteComment)
				{
					onDeleteComment(deletedItem)
				}
			}	
			catch(err)
			{
				console.log(err);
			}
		}) 
	}

	const updateFromInsertedReplyList = (updatedItem) => {
		let newInsertedReplyList = [...insertedReplyList];
		let isModified = false;
		for(let i = 0; i < newInsertedReplyList.length; ++i)
		{
			if(parseInt(newInsertedReplyList[i]['no']) === parseInt(updatedItem['no']))
			{ 
				newInsertedReplyList[i] = {
					...newInsertedReplyList[i],
					...updatedItem
				}
				isModified = true;
			}
		}
		if(isModified)
		{
			setInsertedReplyList(newInsertedReplyList)	
		}
	}
	const removeFromInsertedReplyList = (commentNo) => {
		let newInsertedReplyList = [...insertedReplyList];
		let isModified = false;
		for(let i = 0; i < newInsertedReplyList.length; ++i)
		{
			if(parseInt(newInsertedReplyList[i]['no']) === parseInt(commentNo))
			{
				newInsertedReplyList = removeItem(newInsertedReplyList,i);
				isModified = true;
			}
		}
		if(isModified)
		{
			setInsertedReplyList(newInsertedReplyList)	
		}
	}
	const showAddCommentBtn =  (listItemType === 'comment_list_item') ? true: false;
	return ( 
		<>
		<Presenter 
		comment={comment}
		showAddComment={showAddCommentBtn}
		wrapperStyle={wrapperStyle}
		onClickAddComment={()=>{
			setShowAddCommentModal(true);
		}}
		onClickLikeComment={()=>{
			likeComment();
		}}
		onClickUnlikeComment={()=>{
			unlikeComment();
		}}
		showOption={(currUserNo === commentUserNo)}
		onClickOption={(commentNo)=>{
			setBottomModalVisible(true);
			setBottomModalDataList([
				{type: 'callback', text: '수정', callback: () => {setBottomModalVisible(false);setShowEditModal(true)}, style: {color: '#000000'}},
				{type: 'callback', text: '삭제', callback: () => {setBottomModalVisible(false);deleteComment()}, style: {color: '#DE0000'}}
			])
		}}
		/>  
		{
			((['comment_list_item', 'reply_list_parent'].includes(listItemType)) &&  (
				<div style={{paddingLeft: `calc(100vw*(36/375))`, marginBottom :`calc(100vw*(12/375))` }}>
				<CommentReplyList   
				insertedItemList={insertedReplyList}
				deletedItem={deletedReplyItem}
				updatedItem={updatedReplyItem}
				parentListType={listType}
				parentListItemType={listItemType}
				type={type}
				targetNo={targetNo}
				parentNo={comment['no']}
				initReplyList={initReplyList}
				totalReply={comment.total_reply}
				onReplyInserted={(insertedItem)=>{if(onReplyInserted)onReplyInserted(insertedItem)}}
				onReplyDeleted={(deletedItem)=>{
					if(onReplyDeleted)
					{
						onReplyDeleted(deletedItem)
					}
					removeFromInsertedReplyList(deletedItem['no'])
				}}
				onReplyUpdated={(updatedItem)=>{
					updateFromInsertedReplyList(updatedItem)
					setUpdatedReplyItem(updatedItem);
					if(onReplyUpdated)
					{
						onReplyUpdated(updatedItem)
					}
				}}
				/>
				{((showAddCommentBtn && initReplyList?.length > 0) &&
					<AddCommentReplyBtnBar 
					onClick={()=>{
						setShowAddCommentModal(true);
					}
				}
				/>
				)}

				</div>
				)
			)
		}
		{
			((['comment_list_item' ].includes(listItemType))&& (
				<CreateCommentReplyModal 
				type={type}
				targetNo={targetNo}
				commentNo={comment['no']}
				visible={showAddCommentModal} 
				setVisible={(isVisible)=>{setShowAddCommentModal(isVisible)}} 

				onUpdateComment={(updatedItem)=>{if(onUpdateComment)onUpdateComment(updatedItem)}}
				onDeleteComment={(deletedItem)=>{if(onDeleteComment)onDeleteComment(deletedItem)}}
				onReplyInserted={(insertedItem)=>{
					setInsertedReplyList([...insertedReplyList, insertedItem])
				}}
				onReplyDeleted={(deletedItem)=>{
					setDeletedReplyItem(deletedItem);
					removeFromInsertedReplyList(deletedItem['no'])
				}}
				onReplyUpdated={(updatedItem)=>{
					updateFromInsertedReplyList(updatedItem)
					setUpdatedReplyItem(updatedItem);
					if(onReplyUpdated)
					{
						onReplyUpdated(updatedItem)
					}
				}}
				/>
				)
			)
		}
		<EditCommentModal 
			visible={showEditModal} setVisible={setShowEditModal} 
			type={type} 
			initContent={comment['content']}
			commentNo={comment['no']}
			onUpdateComment={(updatedComment)=>{
				if(onUpdateComment)
				{
					onUpdateComment(updatedComment)
				}
			}}
		/>
		<BottomModal visible={bottomModalVisible} setVisible={setBottomModalVisible} dataList={bottomModalDataList}/>
		</>
	); 
}

const Spacer = styled.div`
height: ${({currHeight}) => currHeight && `${currHeight}`}px;
min-height: ${({currHeight}) => currHeight && `${currHeight}`}px;
margin-top: calc(100vw * (35 / 375));
`;
